const PUBLIC_ROUTES = ["/account/login", "/account/forgot-password"];

const AUTH_FLOW_PATHS = [
  "/auth/login",
  "/auth/forgotPassword",
  "/auth/changePasswordWithOtp",
];

let sessionExpiryHandled = false;

export function isPublicRoute(pathname = window.location.pathname) {
  return PUBLIC_ROUTES.some((route) => pathname.startsWith(route));
}

export function isAuthFlowRequest(url = "") {
  return AUTH_FLOW_PATHS.some((path) => url.includes(path));
}

export function getApiErrorMessage(error) {
  if (!error) return "";

  const data = error.data ?? error.error?.data;

  if (typeof data === "string") {
    try {
      const parsed = JSON.parse(data);
      return parsed?.message || data;
    } catch {
      return data;
    }
  }

  return data?.message || error.message || "";
}

export function isSessionExpiredError(status, message = "", url = "") {
  if (isAuthFlowRequest(url)) {
    return false;
  }

  const lower = message.toLowerCase();

  if (
    lower.includes("no refresh token") ||
    lower.includes("refresh token") ||
    lower.includes("no token found") ||
    lower.includes("invailed token") ||
    lower.includes("invalid token please login")
  ) {
    return true;
  }

  if (lower.includes("your account is")) {
    return true;
  }

  if (Number(status) === 401) {
    return true;
  }

  return false;
}

export function isSessionExpiredApiError(error, url = "") {
  if (sessionExpiryHandled) {
    return true;
  }

  const status = error?.status ?? error?.originalStatus;
  const message = getApiErrorMessage(error);

  return isSessionExpiredError(status, message, url);
}

export function isSessionExpiryHandled() {
  return sessionExpiryHandled;
}

export function forceSessionLogout(message = "Session expired. Please sign in again.") {
  if (sessionExpiryHandled || isPublicRoute()) {
    return;
  }

  sessionExpiryHandled = true;
  clearAuthSession();
  sessionStorage.setItem("sessionExpiredMessage", message);
  window.location.href = "/account/login";
}

export function consumeSessionExpiredMessage() {
  const message = sessionStorage.getItem("sessionExpiredMessage");
  sessionStorage.removeItem("sessionExpiredMessage");
  return message;
}

export function setAuthSession(user) {
  sessionStorage.setItem("auth", "1");
  if (user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
}

export function clearAuthSession() {
  sessionStorage.removeItem("auth");
  localStorage.removeItem("user");
}
